import styled from 'styled-components'

export const MediaColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

/* Moldura estável: altura fixa + object-fit centralizado, para fotos de tamanhos
   diferentes não mudarem a altura e quebrarem o layout. */
export const StaticImage = styled.img<{
  $maxHMobile: string
  $maxHDesktop: string
}>`
  height: ${({ $maxHMobile }) => $maxHMobile};
  width: 100%;
  object-fit: contain;

  @media (min-width: 768px) {
    height: ${({ $maxHDesktop }) => $maxHDesktop};
  }
`
